<script lang="ts">
	import { PlayIcon } from '../../../assets/icons/PlayIcon';
</script>

<div
	class="bg-gray-0 absolute bottom-4 left-4 flex h-12 w-12 items-center justify-center rounded-full"
>
	<PlayIcon color="text-gray-0" />
</div>
